/**
 * Adds the featured product and sends the shopper to checkout.
 */
(function () {
  function handleBuyNow(event) {
    var button = event.currentTarget;
    var root = button.closest('product-info');
    var idInput = root && root.querySelector('product-form input[name="id"]');
    var quantityInput = root && root.querySelector('.quantity__input');

    if (!idInput || idInput.disabled) return;

    button.disabled = true;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: idInput.value,
        quantity: quantityInput ? Number(quantityInput.value) || 1 : 1,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add the product.');
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = rootUrl + 'checkout';
      })
      .catch(function () {
        button.disabled = false;
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-featured-buy-now]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', handleBuyNow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
